// import React from "react";
// import "../styles/AlertPopUpStyles.css"; // Import styles
// import tapImg from "../assets/images/assessment/assessment_popup_tab.png";
// import bgImg from "../assets/images/assessment/assessment_popup_bg.jpg";

// interface PopupProps {
//   onClose: () => void;
//   body:string
// }

// const ErrorAlertPopup: React.FC<PopupProps> = ({ onClose,body }) => {
//   return (
//     <div className="alertpopup-overlay">
//       <div className="alertpopup-container">
//         <div className="alertpopup-header">
//           <h2>Error</h2>
//         </div>
//         <div
//           className="alertpopup-body"
//           style={{
//             display: "flex",
//             flexDirection: "column", // Arrange children in a column
//             margin: "0",
//             justifyContent: "center",
//             alignItems: "center",
//             textAlign: "center",
//             backgroundImage: `url(${bgImg})`, // Replace with your image URL
//             backgroundSize: "cover", // Ensure the image covers the entire background
//             backgroundRepeat: "no-repeat", // Prevent the image from repeating
//             backgroundPosition: "center", // Center the image
//             padding: "20px", // Optional: Add padding for spacing
//           }}
//         >

//           <div>
//             <p
//               style={{
//                 textAlign: "center",
//                 color: "#353535",
//                 fontFamily: "Mazzard",
//                 fontSize: "20px",
//                 fontWeight: "400",
//                 marginTop: "10px", // Add margin above the text for spacing
//               }}
//             >
//               {body}
//             </p>
//           </div>
//         </div>

//         <div className="alertpopup-footer">
//           <button onClick={onClose} className="alertpopup-button">
//                 OK
//             </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ErrorAlertPopup;

import React from "react";
import "../styles/ErrorAlertPopup.css"; // Move common styles to a CSS file
// import bgImg from "path-to-your-background-image"; // Replace with your image path

interface PopupProps {
  btn1Pressed: () => void;
  btn2Pressed: () => void;
  body: string;
  subBody: string;
}

const ErrorAlertPopup: React.FC<PopupProps> = ({
  body,
  subBody,
  btn1Pressed,
  btn2Pressed,
}) => {
  return (
    <div className="Error-alertpopup-overlay">
      <div className="Error-alertpopup-container-logout">
        {/* Header */}
        <div
          className="Error-alertpopup-header"
          style={{
            backgroundColor: "#D40E0E",
            height: "50px",
            color: "#FFF",
            textAlign: "center",
            paddingTop: "10px",
            fontSize: "18px",
            fontFamily: "Mazzard",
            fontWeight: 500,
          }}
        >
          Confirmation
        </div>

        {/* Body */}
        <div
          className="Error-alertpopup-body"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            // backgroundImage: `url(${bgImg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            // padding: "20px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              color: "#2D2D2D",
              fontFamily: "Mazzard",
              fontSize: "16px",
              fontWeight: 500,
              marginTop: "10px",
            }}
            dangerouslySetInnerHTML={{ __html: body }}
          ></p>
          <p
            style={{
              textAlign: "center",
              color: "#2D2D2D",
              fontFamily: "Mazzard",
              fontSize: "16px",
              fontWeight: 500,
              marginTop: "10px",
            }}
          >
            {subBody}
          </p>
        </div>

        <div
          className="Error-alertpopup-footer"
          style={{
            borderTop: "none",
            display: "flex",
            justifyContent: "center",
            gap: "15px", // Small gap between buttons
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          <button
            onClick={btn1Pressed}
            style={{
              backgroundColor: "#FFC85D",
              color: "#1A1F24",
              fontFamily: "Mazzard",
              fontSize: "16px",
              fontWeight: 600,
              width: "70px", // Fixed width for equal button size
              height: "35px",
              borderRadius: "8px",
              cursor: "pointer",
              textAlign: "center",
              borderColor: "transparent",
            }}
            className="ErrorButton"
          >
            Yes
          </button>
          <button
            onClick={btn2Pressed}
            style={{
              borderColor: "transparent",
              backgroundColor: "#CACACA",
              color: "#1A1F24",
              fontFamily: "Mazzard",
              fontSize: "16px",
              fontWeight: 600,
              textAlign: "center",
              width: "70px", // Fixed width for equal button size
              height: "35px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            className="ErrorButton"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorAlertPopup;
